
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var tealiumImageClickEvent = false;
const constants = require('../constants');

/* eslint-disable require-jsdoc */
/* eslint-disable no-underscore-dangle */
function ZoomService() {
    this._$document = $(document);
    this._$window = $(window);
    this._$body = $(document.body);
    this._$modal = $('.product-images__modal');
}


/**
 * Handle thumbnail image when click on pdp
 * @param {JQuery} $elem - zoom element
 * @param {Object} modalContainer - conatiner of modal when user click on image on pdp
 */
function handleThumbnailOnClick($elem, modalContainer) {
    $('.product-image--thumb.active').removeClass('active');
    let clickedImageIndex = $elem.attr('href').split('#')[1];
    let scrollTo = $('.product-image--large[data-index=' + clickedImageIndex + ']');
    // eslint-disable-next-line
    let position = scrollTo.offset().top - modalContainer.offset().top + modalContainer.scrollTop();
    var imageSrc = $elem.find('source') ? $elem.find('source')[0].getAttribute('srcset') : '';
    tealiumEnable.getAnalyticsData('handleProductImageEvent', imageSrc, 'thumbImgClick');
    $('.modal').animate({
        scrollTop: position
    }, 500);
}

ZoomService.prototype.listen = function () {
    if (window.outerWidth > constants.breakpoints.lg) {
        this._$body.off('click.zoomContainer').on('click.zoomContainer', '.swiper-zoom-container  [data-target="#productImagesModal"]', $.proxy(this._zoomApply, this));
    }

    this._$body.off('click.largeImage').on('click.largeImage', '.zoomed-images--desk .image-large img', $.proxy(this._zoomRemove, this));
    this._$modal.off('click.largeScroll').on('click.largeScroll', 'a.large-scroll', $.proxy(function (event) {
        event.preventDefault();
        var modalContainer = $('#productImagesModal');
        handleThumbnailOnClick($(event.currentTarget), modalContainer);
    }, this));
};

ZoomService.prototype._zoomRemove = function () {
    if (window.outerWidth < constants.breakpoints.lg) {
        var clbImg = $('.product-image__wrapper .product-image').find('img').data('iscolab');
        var gotoIndex = $('.product-image--large.swiper-slide-active').data('index');
        document.querySelector('.zoomed-images--mob').swiper.zoom.out(); // Zoom out to the initial state
        if (clbImg) {
            gotoIndex += 1;
        }
        document.querySelector('.product-images--primary').swiper.slideTo(gotoIndex, 0);
        $('.zooming-wrap').remove();
    }
};

var thumbImgClicked = false;

/**
 * Scroll stop listener
 * @param {HTMLElement} element element
 * @param {function} callback cb function
 * @param {number} timeout for callback in ms
 * @returns {function} - removes event listener
 */
function scrollStopListener(element, callback, timeout) {
    var handle = null;
    var onScroll = function () {
        if (handle) {
            clearTimeout(handle);
        }
        handle = setTimeout(callback, timeout || 200);
    };
    element.addEventListener('scroll', onScroll);
    return function () {
        element.removeEventListener('scroll', onScroll);
    };
}

ZoomService.prototype._zoomApply = function (e) {
    e.preventDefault();
    var isBundleProduct = $('.product-set-detail').length;
    let delayTime = isBundleProduct ? Number(1000) : Number(300);
    var props;
    try {
        props = e.target.getBoundingClientRect();
    } catch (err) {
        return;
        // Catch error when e.target is null
    }
    var imageIndex = e.target.getAttribute('data-imageindex');
    var imageSrc = e.target.getAttribute('src');
    var modal = this._$modal;
    var $thumbnails = $('.image-thumbnails', modal);
    var $closeBtn = $('.close', modal);
    $('.image-thumbnails .product-image--thumb').removeClass('active');
    tealiumEnable.getAnalyticsData('productImageInteractionEvent', tealiumImageClickEvent);
    tealiumImageClickEvent = true;
    $thumbnails.removeClass('show');
    $closeBtn.hide();
    $('.zoomed-image-main').addClass('modal-off');
    $('.product-image--large').removeClass('zoom-select');
    $('#productImagesModal').off('show.bs.modal').on('show.bs.modal', function () {
        if (isBundleProduct) {
            $('.zooming-wrap').remove();
            var imageElem = `<div class="zooming-wrap"><div class="product-image--large col-12"><a><img src="${imageSrc}" alt="Zooming image"></a></div></div>`;
            $('.image-large').before(imageElem);
        }
    });
    $('#productImagesModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
        try {
            gotoIndex = $('.zoomed-images--mob .swiper-slide-active').data('image-index');
            const swiperInstance = document.querySelector('.product-images--primary').swiper;
            if (swiperInstance) {
                swiperInstance.slideTo(gotoIndex, 0);
            }

            $('.zoomed-image-main').addClass('modal-off');
            $('.product-image--large').removeClass('zoom-select');
        } catch (error) {
            // error handling
        }
    });
    // To position the modal to origin place
    modal.css(
        {
            width: props.width,
            height: props.height,
            top: props.top,
            left: props.left
        }, 0).promise().done(function () {
        // To zoom the modal with image from origin place
            modal.animate(
                {
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    margin: 0,
                    padding: 0,
                    transition: 'all 0.3s'
                }, 300).promise().done(function () {
                    setTimeout(
                        function () {
                            var currentImage = $(`.zoomed-image-main > [data-index="${imageIndex}"] .swiper-zoom-container img`).get(0).getBoundingClientRect();
                            $('.modal-open .modal').scrollTop((currentImage.height * imageIndex) + (16 * imageIndex));
                            $(`.product-image--large[data-index=${imageIndex}]`).addClass('zoom-select');

                            $thumbnails.addClass('show');
                            $closeBtn.show();
                            $thumbnails.find(`.product-image--thumb a img[data-imageindex="${imageIndex}"]`).closest('.product-image--thumb').addClass('active');

                            $('.zoomed-image-main').removeClass('modal-off');
                            const productImages = document.querySelectorAll('.product-image--large');
                            const productThumbImages = document.querySelectorAll('.product-image--thumb');
                            const productModal = document.querySelector('.product-images__modal');

                            $(productModal).on('click', '.product-image--thumb', function () {
                                $(this).parent().find('.active').removeClass('active');
                                $(this).addClass('active');
                                thumbImgClicked = true;
                            });

                            $(productModal).on('scroll', (el) => {
                                el.preventDefault();
                                let productImageObserver = new IntersectionObserver(function (entries) {
                                    entries.forEach(function (entry) {
                                        if (entry.isIntersecting) {
                                            const getDataIndexOfCurrentVisibleImage = entry.target.getAttribute('data-index');
                                            if (!thumbImgClicked) {
                                                $(productThumbImages).removeClass('active');
                                                $($(productThumbImages)[getDataIndexOfCurrentVisibleImage]).addClass('active');
                                            }
                                        }
                                    });
                                }, { threshold: 0.3 });

                                productImages.forEach(function (productImage) {
                                    productImageObserver.observe(productImage);
                                });

                                if (thumbImgClicked) {
                                    scrollStopListener(productModal, function () {
                                        thumbImgClicked = false;
                                    }, 100);
                                }
                            });
                        }, delayTime);
                });
        });
};

export default {
    init: () => {
        const zoomService = new ZoomService();
        zoomService.listen();
    }
};
